import Grid from "@material-ui/core/Grid";
import { createStyles, Theme, WithStyles, withStyles } from "@material-ui/core/styles";
import React from "react";
import { StaticContext } from "react-router";
import { Redirect, Route, RouteComponentProps, RouteProps } from "react-router-dom";
import { isUserSignedIn } from "../../auth";

const styles = (theme: Theme) =>
  createStyles({
    container: {
      height: "100%",
    },
  });

interface SignOutRouteProps extends RouteProps, WithStyles<typeof styles> {}

export const SignOutRouteComponent = (props: SignOutRouteProps) => {
  const { render, classes, ...rest } = props;

  const signOutRouteRender = (routeProps: RouteComponentProps<any, StaticContext>) =>
    !isUserSignedIn() ? (
      <Redirect to={"/auth/signed-out"} />
    ) : (
      render && (
        <Grid container={true} className={classes.container} spacing={0}>
          <Grid item={true} xs={12}>
            {render(routeProps)}
          </Grid>
        </Grid>
      )
    );

  return <Route {...rest} render={signOutRouteRender} />;
};

export const SignOutRoute = withStyles(styles)(SignOutRouteComponent);
